(function () {
  'use strict';

  angular.module('app').component('hotelContentList', hotelContentList());

  function hotelContentList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onHotelContentShowed: '&',
        websiteId: '<',
        defaultLanguage: '<',
      },
      controller: HotelContentListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/hotel-contents/hotel-content-list/hotel-content-list.component.html',
    };
  }

  HotelContentListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'HotelContentService',

    // Angular downgraded service
    'locationService',
  ];

  function HotelContentListComponent(
    config,
    UtilService,
    AbilityService,
    HotelContentService,

    // Angular downgraded service
    locationService
  ) {
    let vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_hotel_accountadmin'),
      canUpdate: AbilityService.can('update_hotel_accountadmin'),
      canDestroy: AbilityService.can('destroy_hotel_accountadmin'),
    };

    vm.featuredOptions = config.BOOLEAN_OPTIONS;
    vm.publishedOptions = config.BOOLEAN_OPTIONS;

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = HotelContentService.getFilterCriteria();

    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.deleteItem = deleteItem;
    vm.changeItemStatus = changeItemStatus;
    // vm.onUpdateItems       = onUpdateItems;
    vm.changeItemFeatured = changeItemFeatured;
    vm.changeItemPublished = changeItemPublished;

    vm.searchLocations = (search) => {
      if (search.length < 2) {
        return;
      }

      let params = {
        get: 'active',
        by_name: search,
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      locationService.getLocations(params).subscribe((response) => {
        vm.locations = response;
      });
    };

    vm.clearLocations = () => {
      vm.locations = [];

      vm.UtilService.filterResult();
    };

    function fetchResult() {
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      HotelContentService.getHotelsContents(vm.websiteId, vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.locations = [];

      vm.filterCriteria = HotelContentService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item) {
      if (!vm.permissions.canShow) {
        return;
      }

      vm.onHotelContentShowed({ item: item });
    }

    function deleteItem(item) {
      if (!vm.permissions.canDestroy) {
        return;
      }

      HotelContentService.deleteHotelContent(item, fetchResult);
    }

    function changeItemStatus(item) {
      if (!vm.permissions.canUpdate) {
        return;
      }

      HotelContentService.changeHotelContentStatus(item);
    }

    /*function onUpdateItems(action) {
            let successCallback = function(){
                vm.showActions = false;
                vm.selectedAll = false;

                if (action === 'destroy'){
                    fetchResult();
                }
            };
            
            HotelContentService.updateHotelsContents(action, vm.items, successCallback);
        }*/

    function changeItemFeatured(item) {
      HotelContentService.changeHotelContentFeatured(item);
    }

    function changeItemPublished(item) {
      if (!vm.permissions.canUpdate) {
        return;
      }

      HotelContentService.changeHotelContentPublished(item);
    }
  }
})();
